module.exports = __webpack_public_path__ + "media/video-2.250aad3c.mp4";